import httpService from '@/modules/common/services/httpService';

const basePlatformRoute = '/platform/v1/scheduling';

const fetchAppointments = async (uids, matterUid, clientUid, perPage = 25) => {
  // Input validation
  if (!Array.isArray(uids) || uids.length === 0) {
    throw new Error('uids must be a non-empty array');
  }

  if (!clientUid) {
    throw new Error('clientUid is required');
  }

  try {
    const response = await httpService.get(`${basePlatformRoute}/appointments`, {
      uids: uids.join(','),
      matter_uid: matterUid,
      client_id: clientUid,
      per_page: perPage,
    });

    return response.data?.data?.appointments || [];
  } catch (error) {
    console.error('Error fetching appointments:', error);
    throw error; // Re-throw for caller to handle
  }
};

export default {
  fetchAppointments,
};
